import { IconButton, Text } from 'office-ui-fabric-react';
import { NotificationStatusTag } from '../../../../../../../components/NotificationStatusTag';
import { notificationSentAsResolver } from '../../../../../../../utilities/notificationSentAsResolver';

function columns(translator, onDeleteSingle, onDeleteFromAll) {
  return [
    {
      key: 'name',
      name: translator(
        'pages.createHearing.createHearingInvitations.inviteesList.sourceMappingNameColumn',
      ),
      ariaLabel: translator(
        'pages.createHearing.createHearingInvitations.inviteesList.sourceMappingNameColumn',
      ),
      fieldName: 'name',
      minWidth: 150,
      maxWidth: 150,
      isResizable: true,
    },
    {
      key: 'invitationKey',
      name: translator(
        'pages.createHearing.createHearingInvitations.inviteesList.sourceMappingIdentifierColumn',
      ),
      ariaLabel: translator(
        'pages.createHearing.createHearingInvitations.inviteesList.sourceMappingIdentifierColumn',
      ),
      fieldName: 'invitationKey',
      minWidth: 150,
      maxWidth: 200,
      isResizable: true,
    },
    {
      key: 'invitationStatus',
      name: translator(
        'pages.createHearing.createHearingInvitations.inviteesList.notificationStatus',
      ),
      ariaLabel: translator(
        'pages.createHearing.createHearingInvitations.inviteesList.notificationStatus',
      ),
      minWidth: 120,
      maxWidth: 150,
      isResizable: true,
      onRender: (item) => {
        return (
          <div>
            <NotificationStatusTag
              status={item.data.notificationStatus}
              isSent={item.data.isSentToQueue}
              translator={translator}
            />
          </div>
        );
      },
    },
    {
      key: 'sentAs',
      name: translator(
        'pages.createHearing.createHearingInvitations.inviteesList.sourceMappingSentAsColumn',
      ),
      ariaLabel: translator(
        'pages.createHearing.createHearingInvitations.inviteesList.sourceMappingSentAsColumn',
      ),
      fieldName: 'sentAs',
      minWidth: 90,
      maxWidth: 90,
      isResizable: true,
      onRender: (item) => {
        return notificationSentAsResolver(
          translator,
          item.sentAs,
          item.data.isSentToQueue,
        );
      },
    },
    {
      key: 'deleteSingle',
      name: translator(
        'pages.createHearing.createHearingInvitations.inviteesList.deleteInvitationSourceMapping',
      ),
      ariaLabel: translator(
        'pages.createHearing.createHearingInvitations.inviteesList.deleteInvitationSourceMapping',
      ),
      minWidth: 90,
      maxWidth: 90,
      isResizable: true,
      onRender: (item) =>
        !item.data.canDeleteIndividuals ? (
          <Text>
            {translator(
              'pages.createHearing.createHearingInvitations.inviteesList.notPossibleToDeleteFromSource',
            )}
          </Text>
        ) : (
          <IconButton
            iconProps={{ iconName: 'Delete' }}
            title={translator(
              'pages.createHearing.createHearingInvitations.inviteesList.deleteInvitationSourceMapping',
            )}
            ariaLabel={translator(
              'pages.createHearing.createHearingInvitations.inviteesList.deleteInvitationSourceMapping',
            )}
            onClick={(_event) => onDeleteSingle(item.data.id)}
          />
        ),
    },
    {
      key: 'deleteFromAllSources',
      name: translator(
        'pages.createHearing.createHearingInvitations.inviteesList.deleteInvitationSourceMappingGroupForUserOrCompany',
      ),
      ariaLabel: translator(
        'pages.createHearing.createHearingInvitations.inviteesList.deleteInvitationSourceMappingGroupForUserOrCompany',
      ),
      minWidth: 120,
      maxWidth: 150,
      isResizable: true,
      onRender: (item) =>
        !item.data.canDeleteIndividuals ? (
          <Text>
            {translator(
              'pages.createHearing.createHearingInvitations.inviteesList.notPossibleToDeleteFromSource',
            )}
          </Text>
        ) : (
          <IconButton
            iconProps={{ iconName: 'DeleteRows' }}
            title={translator(
              'pages.createHearing.createHearingInvitations.inviteesList.deleteInvitationSourceMappingGroupForUserOrCompany',
            )}
            ariaLabel={translator(
              'pages.createHearing.createHearingInvitations.inviteesList.deleteInvitationSourceMappingGroupForUserOrCompany',
            )}
            onClick={(_event) => onDeleteFromAll(item.data.id)}
          />
        ),
    },
  ];
}

export { columns };
